module.exports = __webpack_public_path__ + "static/media/galaxies-02.b00b6793.png";